import appLocaleData from 'react-intl/locale-data/de';
import deMessages from '../locales/de-DE';

const DeLang = {
    messages: {
        ...deMessages
    },
    locale: 'de-DE',
    data: appLocaleData
};
export default DeLang;